import styled, { css } from "styled-components";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import InputMask from "react-input-mask";

export const Label = styled.label`
  ${({ theme, error }) => css`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: none;
    pointer-events: none;
    font-size: ${theme.font.sizes.medium};
    font-weight: 500;
    font-family: Roboto !important;
    color: ${theme.colors.gray};
    border-bottom: ${error ? "1px solid #f00909" : "1px solid #ddd"};

    .content__name {
      position: absolute;
      bottom: 0.5rem;
      transition: all 0.3s ease-in-out;
    }

    &::after {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      bottom: -1px;
      border-bottom: ${error
        ? "1px solid #f00909"
        : `1px solid ${theme.colors.lineBlue}`};
      transform: translateX(-100%);
      transition: all 0.5s ease-in-out;
    }

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.medium};
    }

    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
  `}
`;
export const Input = styled(InputMask)`
  padding-top: 2.6rem;
  width: 100%;
  border: 0;
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large};

    /* @media (min-width: 500px) {
      font-size: 1.4rem;
    } */

    ::placeholder {
      color: transparent;
    }

    &:focus + ${Label} .content__name,
    &:not(:placeholder-shown) + ${Label} .content__name {
      transform: translateY(-100%);
      left: 0;
      font-size: 1.4rem;
    }

    &:focus + ${Label}::after, &:not(:placeholder-shown) + ${Label}::after {
      transform: translateX(0);
    }
    /* @media (max-width: 500px) {
      font-size: 1.4rem;
  } */
  `}
`;
export const InputCPFCNPJ = styled(CpfCnpj)`
  padding-top: 2.6rem;
  width: 100%;
  border: 0;
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large};

    /* @media (min-width: 500px) {
      font-size: 1.4rem;
    } */

    ::placeholder {
      color: transparent;
    }

    &:focus + ${Label} .content__name,
    &:not(:placeholder-shown) + ${Label} .content__name {
      transform: translateY(-100%);
      left: 0;
      font-size: 1.4rem;
    }

    &:focus + ${Label}::after, &:not(:placeholder-shown) + ${Label}::after {
      transform: translateX(0);
    }
    /* @media (max-width: 500px) {
      font-size: 1.4rem;
  } */
  `}
`;

export const Container = styled.div`
  ${({ width = "100%" }) => css`
    width: ${width};
    position: relative;
    overflow: hidden;

    @media (min-width: 1600px) {
      margin-top: 0.5rem;
    }
  `}
  ${({ theme }) => css`
    input[disabled] {
      background-color: transparent;
      color: ${theme.colors.grayThird};
    }
  `}

  .input {
    padding-top: 2.6rem;
    width: 100%;
    border: 0;

    ${({ theme }) => css`
      font-size: 1.6rem;

      ::placeholder {
        color: transparent;
      }

      &:focus + ${Label} .content__name,
      &:not(:placeholder-shown) + ${Label} .content__name {
        transform: translateY(-100%);
        left: 0;
        font-size: 1.4rem;
      }

      &:focus + ${Label}::after, &:not(:placeholder-shown) + ${Label}::after {
        transform: translateX(0);
      }
    `}
  }
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0;
    bottom: 0;
    svg {
      color: ${theme.colors.primary};
    }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0;
    bottom: 0;
    svg {
      color: ${theme.colors.primary};
    }
  `}
`;
